export default __webpack_public_path__ + "static/media/arrow-down.7c567ecd.svg";